<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 17.995 17.991">
        <g id="search_3_" data-name="search (3)" transform="matrix(1, 0.017, -0.017, 1, 0.309, 0)">
            <g id="Group_2436" data-name="Group 2436" transform="translate(0 0)">
                <g id="Group_2435" data-name="Group 2435" transform="translate(0 0)">
                    <path id="Path_69813" data-name="Path 69813"
                          d="M15.7,1.99a6.771,6.771,0,0,0-9.821,9.317l-.517.517a1.07,1.07,0,0,0-1.513,0h0l-3.53,3.53a1.07,1.07,0,0,0,0,1.513h0l.5.5a1.07,1.07,0,0,0,1.513,0l3.53-3.53a1.07,1.07,0,0,0,0-1.513h0l.517-.517A6.771,6.771,0,0,0,15.7,1.99Zm-.5,9.078a6.062,6.062,0,1,1,0-8.574A6.062,6.062,0,0,1,15.191,11.068Z"
                          fill="#fff"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ISearch",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
